import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "./sentry";
import { LocaleProvider } from "./i18n";
import { ThemeProvider } from "./theme/ThemeProvider";
import App from "./App";
import "./index.css";

initSentry();

// Register the service worker once after first paint so install/activate
// don't block the React mount. Failures are silent — PWA installability is
// nice-to-have, not required.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/play/sw.js", { scope: "/play/" }).catch(() => {});
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <LocaleProvider>
        <App />
      </LocaleProvider>
    </ThemeProvider>
  </StrictMode>,
);
